import React from 'react';

import TextWrapper from './styled/TextWrapper';

const Text = ( { align = 'lefts', size, children } ) => <TextWrapper align={align} size={ size }>{ children }</TextWrapper>;


export default Text;
